import { createToast } from "./toast-message";
import { basket } from "../vue/helpers/products/basket-store.js";

(function () {
	function init() {
		basket.isLoading = true;

		let data = {
			action: "acc_get_basket_items",
			url: window.location.href,
			nonce: phpVals.btNonce,
		};

		const params = new URLSearchParams(data);

		wordPressRequest("POST", phpVals.adminAjax, params)
			.then((res) => {
				if (res?.api_response) {
					basket.data = res;
					basket.items = res.data;
					basket.urls = res.urls;
				}
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				basket.isLoading = false;
			});
	}

	init();

	async function wordPressRequest(method = "POST", url = "", data) {
		// Default options are marked with *
		const response = await fetch(url, {
			method: method, // *GET, POST, PUT, DELETE, etc.
			credentials: "same-origin", // include, *same-origin, omit
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				"Cache-Control": "no-cache",
			},
			body: data, // body data type must match "Content-Type" header
		});

		return response.json(); // parses JSON response into native JavaScript objects
	}
})();
